(() => {
  const F = window.FLUO;
  const COLORS = ['gelb', 'blau', 'pink'];
  // Display names of the three colors. OLD keeps the previous names working for older variant titles.
  const NAMES = { gelb: 'Pace Yellow', blau: 'Glacier Blue', pink: 'Magenta Flow' };
  const OLD = { gelb: 'Gelb', blau: 'Blau', pink: 'Pink' };
  const BY_NAME = {};
  COLORS.forEach(c => { BY_NAME[NAMES[c]] = c; BY_NAME[OLD[c]] = c; });
  const IMG = c => F.img[c];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const $ = id => document.getElementById(id);
  const money = cents => {
    const n = cents / 100;
    return n.toLocaleString('de-DE', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }) + ' €';
  };
  const sortNames = arr => [...arr].sort((a, b) => COLORS.indexOf(BY_NAME[a]) - COLORS.indexOf(BY_NAME[b]));
  const titleFor = (sel, map) => [...sel].sort((a, b) => COLORS.indexOf(a) - COLORS.indexOf(b)).map(c => map[c]).join(' + ');
  const findVariant = box => box.variants && (box.variants[titleFor(box.sel, NAMES)] || box.variants[titleFor(box.sel, OLD)]);
  const TRASH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M9 7V4h6v3"/></svg>';

  /* header */
  const head = $('head');
  let headState = null;
  const onScroll = () => {
    const s = scrollY > 20;
    if (s !== headState) { headState = s; head.classList.toggle('scrolled', s); }
  };
  addEventListener('scroll', onScroll, { passive: true }); onScroll();
  document.addEventListener('visibilitychange', () => document.body.classList.toggle('paused', document.hidden));

  /* BUY BOXES (default colors come from data-initial in the snippet) */
  const boxes = [...document.querySelectorAll('.buy')];
  const DEFAULTS = { 1: ['pink'], 2: ['blau', 'gelb'], 3: ['gelb', 'blau', 'pink'] };
  const LAYOUT = {
    1: [{ px: '0%', pr: '0deg' }],
    2: [{ px: '-26%', pr: '-6deg' }, { px: '26%', pr: '6deg' }],
    3: [{ px: '-44%', pr: '-9deg' }, { px: '0%', pr: '0deg' }, { px: '44%', pr: '9deg' }]
  };
  const GLOW = { gelb: 'rgba(247,209,23,.24)', blau: 'rgba(30,91,198,.16)', pink: 'rgba(238,42,138,.16)' };

  function paint(box, first) {
    box.imgs.forEach((img, n) => {
      const src = IMG(box.sel[n]);
      if (img.getAttribute('src') === src) return;
      if (first || reduce.matches) { img.src = src; return; }
      img.classList.add('swap');
      setTimeout(() => { img.src = src; img.classList.remove('swap'); }, 200);
    });
    box.querySelectorAll('.pick').forEach((row, n) => {
      row.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', b.dataset.color === box.sel[n] ? 'true' : 'false'));
      const lb = row.querySelector('.lbl b'); if (lb) lb.textContent = NAMES[box.sel[n]];
    });
    box.querySelector('.pic').style.setProperty('--glow', GLOW[box.sel[box.sel.length > 2 ? 1 : 0]]);
    const v = findVariant(box);
    const add = box.querySelector('.add');
    if (add) {
      const ok = v && v.available;
      add.disabled = !ok;
      add.querySelector('span').textContent = ok ? 'In den Warenkorb' : 'Ausverkauft';
    }
    if (box.classList.contains('pdp') && v && !first) {
      const url = new URL(location.href); url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url);
    }
  }

  boxes.forEach(box => {
    const size = +box.dataset.size;
    box.sel = [...DEFAULTS[size]];
    const init = (box.dataset.initial || '').split(' + ').map(t => BY_NAME[t]).filter(Boolean);
    if (init.length === size) box.sel = init;
    const data = box.querySelector('script.variants');
    box.variants = data ? JSON.parse(data.textContent) : null;
    const pic = box.querySelector('.pic');
    box.imgs = LAYOUT[size].map((l, n) => {
      const img = document.createElement('img');
      img.className = 'fl'; img.alt = ''; img.width = 852; img.height = 1846;
      img.style.setProperty('--px', l.px); img.style.setProperty('--pr', l.pr);
      if (size === 3 && n === 1) img.style.zIndex = 2;
      pic.appendChild(img);
      return img;
    });
    const pickers = box.querySelector('.pickers');
    box.sel.forEach((_, n) => {
      const row = document.createElement('div');
      row.className = 'pick';
      const label = size === 1 ? 'Farbe' : 'Flask ' + (n + 1);
      row.innerHTML = `<span class="lbl">${label}<b></b></span><div class="sw" role="group" aria-label="${label}"></div>`;
      const sw = row.querySelector('.sw');
      COLORS.forEach(c => {
        const b = document.createElement('button');
        b.type = 'button';
        b.style.setProperty('--c', `var(--${c})`);
        b.dataset.color = c;
        b.setAttribute('aria-label', NAMES[c]);
        b.title = NAMES[c];
        b.addEventListener('click', () => { box.sel[n] = c; paint(box); if (box.classList.contains('pdp')) document.body.dataset.active = c; });
        sw.appendChild(b);
      });
      pickers.appendChild(row);
    });
    box.querySelector('.add').addEventListener('click', () => addToCart(box));
    paint(box, true);
    if (box.classList.contains('pdp')) document.body.dataset.active = box.sel[0];
  });

  document.querySelectorAll('.cards').forEach(wrap => {
    const io = new IntersectionObserver(entries => {
      if (!entries.some(en => en.isIntersecting)) return;
      wrap.classList.add('in');
      setTimeout(() => wrap.classList.add('done'), 1300);
      io.disconnect();
    }, { threshold: .1 });
    io.observe(wrap);
  });

  /* HERO CAROUSEL (starts on the color set in the hero settings) */
  const stage = $('stage');
  if (stage) {
    const slots = [...stage.querySelectorAll('.slot')];
    const dots = [...document.querySelectorAll('.dot')];
    const hint = $('hint');
    let active = Math.max(0, COLORS.indexOf(stage.dataset.start)), dragMoved = false;
    const preselect = color => boxes.forEach(box => { if (!box.classList.contains('card')) return; box.sel[0] = color; paint(box); });
    const render = () => {
      slots.forEach(slot => {
        const i = COLORS.indexOf(slot.dataset.color);
        const rel = (i - active + 3) % 3;
        const pos = rel === 0 ? 'center' : rel === 1 ? 'right' : 'left';
        slot.classList.remove('center', 'left', 'right');
        slot.classList.add(pos);
        slot.setAttribute('aria-label', pos === 'center' ? `${NAMES[slot.dataset.color]}, ausgewählt` : `${NAMES[slot.dataset.color]} in die Mitte drehen`);
      });
      const c = COLORS[active];
      dots.forEach(d => d.setAttribute('aria-current', d.dataset.color === c ? 'true' : 'false'));
      $('heroName').textContent = 'FLUO ' + NAMES[c];
      $('heroDot').style.setProperty('--c', `var(--${c})`);
      document.body.dataset.active = c;
    };
    const go = n => { active = (n + 3) % 3; render(); preselect(COLORS[active]); hint.classList.add('gone'); };
    slots.forEach(slot => slot.addEventListener('click', e => {
      if (dragMoved) { e.preventDefault(); return; }
      const i = COLORS.indexOf(slot.dataset.color);
      if (i === active) { const sh = $('shop'); if (sh) sh.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth' }); }
      else go(i);
    }));
    dots.forEach(d => d.addEventListener('click', () => go(COLORS.indexOf(d.dataset.color))));
    $('prev').addEventListener('click', () => go(active - 1));
    $('next').addEventListener('click', () => go(active + 1));
    stage.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(active - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(active + 1); }
    });
    let startX = null;
    stage.addEventListener('pointerdown', e => { startX = e.clientX; dragMoved = false; });
    addEventListener('pointermove', e => {
      if (startX === null) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 8) { dragMoved = true; stage.classList.add('dragging'); }
      if (Math.abs(dx) > 60) { go(active + (dx < 0 ? 1 : -1)); startX = e.clientX; }
    });
    const endDrag = () => { startX = null; stage.classList.remove('dragging'); setTimeout(() => { dragMoved = false; }, 0); };
    addEventListener('pointerup', endDrag);
    addEventListener('pointercancel', endDrag);
    render();
  }

  /* CART */
  const countEl = $('cartCount'), list = $('drList'), totalEl = $('drTotal');
  const drawer = $('drawer'), note = $('drNote'), checkout = $('checkout');
  const fsText = $('fsText'), fsBar = $('fsBar');

  async function api(url, body) {
    const res = await fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } });
    const json = await res.json();
    if (!res.ok) throw new Error(json.description || json.message || 'Das hat nicht geklappt.');
    return json;
  }

  /* Singles and Duos are pooled flask by flask and regrouped into the cheapest sets:
     as many Trios as possible, then one Duo for a remainder of two, else one Single.
     So Single + Single = Duo, Duo + Single = Trio, Duo + Duo = Trio + Single. Trios stay as they are. */
  async function bundleUp(cart) {
    const B = F.bundle;
    if (!B || !B.single || !B.duo || !B.trio) return { cart, saved: 0 };
    const singleT = {}, duoT = {}, trioIds = new Set(Object.values(B.trio));
    Object.entries(B.single).forEach(([t, id]) => { singleT[id] = t; });
    Object.entries(B.duo).forEach(([t, id]) => { duoT[id] = t; });
    const names = [], updates = {};
    let singles = 0, duos = 0;
    cart.items.forEach(it => {
      const id = it.variant_id;
      if (singleT[id]) { for (let i = 0; i < it.quantity; i++) names.push(singleT[id]); singles += it.quantity; updates[id] = 0; }
      else if (duoT[id]) { for (let i = 0; i < it.quantity; i++) names.push(...duoT[id].split(' + ')); duos += it.quantity; updates[id] = 0; }
    });
    const n = names.length;
    if (n < 2) return { cart, saved: 0 };
    const trios = Math.floor(n / 3), rem = n % 3;
    const wantDuos = rem === 2 ? 1 : 0, wantSingles = rem === 1 ? 1 : 0;
    if (trios === 0 && wantDuos === duos && wantSingles === singles) return { cart, saved: 0 };
    cart.items.forEach(it => { if (trioIds.has(it.variant_id)) updates[it.variant_id] = (updates[it.variant_id] || 0) + it.quantity; });
    const inc = id => { updates[id] = (updates[id] || 0) + 1; return !!id; };
    let i = 0;
    for (let t = 0; t < trios; t++) { if (!inc(B.trio[sortNames(names.slice(i, i + 3)).join(' + ')])) return { cart, saved: 0 }; i += 3; }
    if (wantDuos) { if (!inc(B.duo[sortNames(names.slice(i, i + 2)).join(' + ')])) return { cart, saved: 0 }; i += 2; }
    if (wantSingles) { if (!inc(B.single[names[i]])) return { cart, saved: 0 }; }
    delete updates.undefined;
    const next = await api(F.routes.cartUpdate, { updates });
    return { cart: next, saved: cart.total_price - next.total_price };
  }

  async function refresh(msg) {
    let cart = await api(F.routes.cart);
    try {
      const r = await bundleUp(cart);
      cart = r.cart;
      if (r.saved > 0) msg = `Zum Set zusammengefasst. Du sparst ${money(r.saved)}.`;
    } catch (e) { cart = await api(F.routes.cart); }
    renderCart(cart);
    note.textContent = msg || '';
    return cart;
  }

  function renderCart(cart) {
    countEl.textContent = cart.item_count;
    totalEl.textContent = money(cart.total_price);
    checkout.toggleAttribute('aria-disabled', !cart.item_count);
    const left = F.freeShip - cart.total_price;
    if (!cart.item_count) fsText.innerHTML = `Versandfrei ab <b>${money(F.freeShip)}</b>`;
    else if (left > 0) fsText.innerHTML = `Noch <b>${money(left)}</b> bis zum kostenlosen Versand`;
    else fsText.innerHTML = '<b>Dein Versand ist kostenlos.</b>';
    fsBar.style.setProperty('--p', Math.min(1, cart.total_price / F.freeShip).toFixed(3));
    if (!cart.items.length) { list.innerHTML = '<p class="dr-empty">Noch leer. Such dir eine Farbe aus.</p>'; return; }
    list.innerHTML = '';
    cart.items.forEach((item, idx) => {
      const colors = (item.variant_title || '').split(' + ').map(t => BY_NAME[t]).filter(Boolean);
      const thumbs = colors.length ? colors.map(c => `<img src="${IMG(c)}" alt="">`).join('') : (item.image ? `<img src="${item.image}" alt="">` : '');
      const title = item.product_title.split(', ').pop();
      const row = document.createElement('div');
      row.className = 'line';
      row.innerHTML = `<div class="thumbs">${thumbs}</div>
        <div class="meta"><b></b><small></small></div>
        <span class="lp">${money(item.final_line_price)}</span>
        <div class="qty"><button type="button" aria-label="Eins weniger">&minus;</button><output>${item.quantity}</output><button type="button" aria-label="Eins mehr">+</button></div>
        <button type="button" class="rm">${TRASH}</button>`;
      row.querySelector('b').textContent = title;
      row.querySelector('small').textContent = colors.length ? colors.map(c => NAMES[c]).join(', ') : (item.variant_title || '');
      row.querySelector('.rm').setAttribute('aria-label', `${title} entfernen`);
      const [minus, plus] = row.querySelectorAll('.qty button');
      const change = q => { row.classList.add('busy'); return api(F.routes.cartChange, { line: idx + 1, quantity: q }).then(() => refresh()).catch(err => { row.classList.remove('busy'); note.textContent = err.message; }); };
      minus.addEventListener('click', () => change(item.quantity - 1));
      plus.addEventListener('click', () => change(item.quantity + 1));
      row.querySelector('.rm').addEventListener('click', () => change(0));
      list.appendChild(row);
    });
  }

  async function addToCart(box) {
    const v = findVariant(box);
    if (!v) return;
    const btn = box.querySelector('.add');
    const msg = box.querySelector('.added');
    btn.disabled = true;
    try {
      await api(F.routes.cartAdd, { items: [{ id: v.id, quantity: 1 }] });
      await refresh();
      msg.textContent = 'Im Warenkorb';
      countEl.classList.add('bump'); setTimeout(() => countEl.classList.remove('bump'), 300);
      openCart();
    } catch (err) {
      msg.textContent = err.message;
    }
    btn.disabled = false;
    msg.classList.add('show');
    clearTimeout(msg.t); msg.t = setTimeout(() => msg.classList.remove('show'), 1800);
  }

  let lastFocus = null;
  function openCart(e) {
    if (e) { e.preventDefault(); refresh().catch(() => {}); }
    if (document.body.classList.contains('cart-open')) return;
    lastFocus = document.activeElement;
    document.body.classList.add('cart-open');
    drawer.removeAttribute('inert'); drawer.setAttribute('aria-hidden', 'false');
    $('closeCart').focus();
  }
  function closeCart() {
    document.body.classList.remove('cart-open');
    drawer.setAttribute('inert', ''); drawer.setAttribute('aria-hidden', 'true');
    if (lastFocus) lastFocus.focus();
  }
  $('cartBtn').addEventListener('click', openCart);
  $('closeCart').addEventListener('click', closeCart);
  $('scrim').addEventListener('click', closeCart);
  addEventListener('keydown', e => { if (e.key === 'Escape' && document.body.classList.contains('cart-open')) closeCart(); });
  checkout.addEventListener('click', e => {
    if (checkout.hasAttribute('aria-disabled')) { e.preventDefault(); note.textContent = 'Dein Warenkorb ist noch leer.'; }
  });
  refresh().catch(() => {});
})();
